import {Dialog} from '@primer/react'
import {useIsLoading} from '../contexts/IsLoadingContext'
import {PreviewsTable} from './previews-table'
import {EnforcementPicker} from './enforcement-picker'
import {PreviewsCountSummary} from './previews-count-summary'
import type {EditablePreview} from '../types'
import {useButton} from '../contexts/ButtonContext'
import {DialogBanner} from './dialog-banner'

type SelectionDialogProps = {
  previews: EditablePreview[]
  isValid?: boolean
  createButtonRef: React.RefObject<HTMLButtonElement | null>
  onCancel(): void
  onSelection(): void
  errorMessage: string | null
}

export function SelectionDialog({
  previews,
  isValid,
  createButtonRef,
  onCancel,
  onSelection,
  errorMessage,
}: SelectionDialogProps) {
  const {buttonRef: returnFocusRef} = useButton()
  const isLoading = useIsLoading()

  return (
    <Dialog
      title="Review import"
      width="large"
      height="large"
      returnFocusRef={returnFocusRef}
      onClose={onCancel}
      footerButtons={[
        {
          buttonType: 'default',
          content: 'Cancel',
          onClick: onCancel,
        },
        {
          buttonType: 'primary',
          content: 'Create rulesets',
          disabled: !isValid,
          loading: isLoading,
          onClick: onSelection,
          ref: createButtonRef,
        },
      ]}
    >
      <Dialog.Body>
        <div className="d-flex flex-column gap-3">
          <DialogBanner errorMessage={errorMessage} />
          <PreviewsCountSummary />
          <EnforcementPicker />
          <PreviewsTable previews={previews} />
        </div>
      </Dialog.Body>
    </Dialog>
  )
}
